<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        怎么起一个好听的名字？看完这篇就够了！
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年2月26日</Col>
      </Row>
      <p></p>
      
      <p>对于广大的起名废而言，起一个音、形、义都比较好，而且适合孩子的名字真是难于上青天。这篇就先来分析一下音形义当中比较容易但是最感性的方面：音律。当前比较主流的是三字名，两字名因为重名率太高我们不推荐，四字名（包括复姓、双姓）比较特殊，我们本篇主要分析单姓三字名。</p>
    
      <div class="contentImg">
        <img src="@/assets/article7.jpg" />
      </div>
      <p style="font-weight:600;">单姓三字名中第一个字为姓，姓的音律已经确定了，而且因为人们的习惯，姓和名之间有天然的停顿（除去采用连姓起名法取的名字，如马在途），所以分析的重点就是姓+两字名的搭配问题。另外，诗词韵律的平仄在名字的分析中我们会适当弱化，因为三字名总共就三个字，而现代汉语把一声、二声当作平声（二声实际上是有变化的），三声、四声当作仄声，这种二分法在名字这个场合下会掩盖太多的细节，就不太合适了。</p>
      <p style="font-weight:600;">因此，三字名音律方面涉及的问题：</p><p></p>
      <p style="font-weight:600;">1、汉语拼音基础知识</p><p></p>
      <p style="font-weight:600;">2、三字之间的声母搭配</p><p></p>
      <p style="font-weight:600;">3、三字之间的韵母搭配</p><p></p>
      <p style="font-weight:600;">4、三字之间的声调搭配</p><p></p>
      <p style="font-weight:600;">5、参考绕口令的创作规律，怎么避免绕口的名字？</p>
      <p></p>
      <h4>1、汉语拼音基础知识</h4>
      <p></p>
      <div class="contentImg">
        <router-link :to="{path: '/artical6'}"><img src="@/assets/article71.jpg" /></router-link>
      </div>
      <h4>2、三字之间的声母搭配</h4>
      <p></p>
      <p>根据上面基础知识的学习，我们把声母的特点做成了一张表：</p>
      <div class="contentImg">
        <img src="@/assets/article72.jpg" />
      </div>
      <p></p>
      <p>因为分类角度的不同，一个声母有多个特征，我们在选择声母搭配的时候，尽量选择不同类型的声母即可。例如，d t n l都是舌尖中音，名字中就尽量不要选择d t n l同时出现的组合，例如“杜泰兰”，“杜太南”读起来就很难受。</p>
      <p></p>
      <p tyle="font-weight:600;">另外，我们经常提到的“五音不全”是哪五音呢？</p>
      <p></p>
      <p>五音和七音是等韵学中声母相关的概念，是古人依发音部位对声母的分类和表记方式。五音的具体所指为：唇音、舌音、牙音、齿音和喉音。后来又细分出半舌音、半齿音两类，合称为七音。</p>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/article73.jpg" />
      </div>
      <p></p>
      <p>五音的发音部位，不同地区的人可能会难度不一样，这个在起名后要多读几次试试。另外就是尽量不要起发音部位一样的音，这样很累的。</p>
      <p></p>
      <h4>3、三字之间的韵母搭配</h4>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/article74.jpg" />
      </div>
      <p></p>
      <p style="font-weight:600;">和声母类似，我们在选择韵母时，也要遵循尽量选择不同类型的韵母。</p>
      <p></p>
      <p>在诗词创作中，“押韵”对韵母的相似性已经做了合并，我们在起名时也尽量避免同时使用同韵的字。建议遵从由中华诗词学会于2005年5月颁布，共分十四韵：</p>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/article75.jpg" />
      </div>
      <p></p>
       <h4>4、三字之间的声调搭配</h4>
      <p></p>
      <p>采用赵元任的五度标记法来描述汉字的声调，有如下四个调（不算轻声）：</p>
      <div class="contentImg">
        <img src="@/assets/article76.jpg" />
      </div>
      <p>从上图我们首先可以直觉的发现：</p>
      <p>阴平调最高，没有变化。</p>
      <p>阳平实际上“不平”，是从中间上升到最高。</p>
      <p>上声从低到高有个反弹，而且变化较多，因此三声字的使用就要特别注意，包括有些三声的姓，如超过一亿人的大姓：李。</p>
      <p>去声从低到高快速下降。</p>
      <p></p>
      
      <h5>4.1 汉字连读时的声调变化</h5>
      <h4 style="font-weight:600;">上声连读</h4>
      <p></p>
      <p>上面我们已经提到了上声是相对最绕口的音，实际上大家平常说话的时候就会不自觉的偷偷变调，只是自己可能还没有发觉。</p>
      <p>两个上声相连，第一个上声会变成阳平。这个其实很好理解，上声拐来拐去，而且还有两个字一起拐，那肯定能不拐就不拐了。举两个最常见的词组：你好，实际上读成“泥好”，老虎实际上读成了“劳虎”。再来个“小老虎”连读三遍试试，看看难受不？</p>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/article77.jpg" />
      </div>
      <p>佛山2020年1月份发布的2019年度热名当中有一个名字叫“梓朗”，重复度排名第18，很难想象吧？而“梓朗”就是两个三声字，而且，汉字中没有 zi 的二声字，这样相当于新造了一个二声的读音。</p>
      <p>如果三声后是其他读音，三声会形成半音，即从214调变成21调。这样来不及向上拐了就停下读后面的字了，例如“梓睿”。</p>
      <p>如果是三个字都是三声，根据我们前面提到的姓+名天然停顿规律，姓会被读成21声。</p>
      <p>假如你姓李，叫李梓朗，恭喜，就会形成一个三字三声连读，你听到的实际上的应该是“li半音zi阳平lang三声”。</p>
      <p style="font-weight:600;">大家可能在看这个文章的时候，会说我读的就是三声啊，但是当你连读，语速较快，没有刻意读的时候，都会形成上面的变调。</p>
      <p>考虑到三声字读起来比较费劲，我们开发的工具对三声字的评分都会适当降低。</p>
      <h4 style="font-weight:600;">去声连读</h4>
      <p>两个去声连读，前一个会从51变成53，即只降半调就停止了。例如“再见”。是不是发现普遍规律了？就是怎么读的连续，舒服，就会怎么来。</p>
      <p>查了一下最新的百家姓数据，去声的姓有：赵、郑、谢、宋、邓、蔡、杜、叶、魏等。这些姓后面的字尽量不要再用去声。</p>
      <div class="contentImg">
        <img src="@/assets/article78.jpg" />
      </div>
      <h4 style="font-weight:600;">“一”和“不”</h4>
      <p>“一”，“不”后面如果是去声，要读阳平。例如，“一个”，“不去”。“一”，“不”后面如果是非去声，要读去声。例如，“一直”。这几年，“一”这个字在名字中使用的也非常多，像“一诺”(移诺)，“一凡”（毅凡），“一帆”（易帆）等。我们很不推荐“一”这个字在名字中使用，不但形体过于简单，读音也比较变化多端。</p>
      <h4 style="font-weight:600;">ABB式的叠音形容词，B很多情况下都读阴平，即一声。</h4>
      <p>例如沉甸甸，红彤彤。</p>
      <div class="contentImg">
        <img src="@/assets/article79.jpg" />
      </div>
      <p>这种叠词方式在名字中也经常使用，我们也非常不推荐，不但存在变调，让人无所适从，而且读起来总感觉像小名，随着孩子年龄的增长，会越来越不合适，总不能对一个老年人天天喊“肖甜甜”吧。</p>
      <p></p>
      <h5>4.2 声调的搭配</h5>
      <p>我们知道了上面的变调规律，我们来看看再来看看声调的搭配就比较好理解了，总的规则是：</p>
      <p>（1）尽量富有变化</p>
      <p>（2）不要使用易变调组合，即3.1所示的情况。</p>
      <p>三字名一共64个声调组合，平仄只有8种，所以我们会弱化平仄。下表中的4星和5星有一定的主观性，供参考，1星和2星的尽量不要用。</p>
      <div class="contentImg">
        <img src="@/assets/article710.jpg" />
      </div>
      <h4>5、避免绕口令式的名字</h4>
      <p>绕口令之所以绕，就是因为采用了近似声母、近似韵母、近似声调的字，然后不断重复，我们在起名时也要避免这种情况。</p>
      <p style="font-weight:600;">避免声母相同或者相似（查声母特征表）</p>
      <p>“华华有两朵红花 红红有两朵黄花 华华想要黄花， 红红想要红花， 华华送给红红一朵红花， 红红送给华华一朵黄花。”</p>
      <p>名字举例：侯红花（都为声母h）</p>
      <p>“黑化肥发灰会挥发，灰化肥挥发会发黑。”</p>
      <p>名字举例：黑化肥（两个声母h 一个f h和f都为擦音）</p>
      <p>“吕小绿家养了红鲤鱼绿鲤鱼和驴。”</p>
      <p>名字举例：吕鲤鱼（前两个同为l 吕和鱼同韵u）</p>
      <div class="contentImg">
        <img src="@/assets/article711.jpg" />
      </div>
      <p style="font-weight:600;">避免韵母相同或者相似（查韵母特征表）</p>
      <p>“苏州有个苏胡子，湖州有个胡夫子，苏胡子问湖夫子借梳子梳胡子。”</p>
      <p>名字举例： 胡复如（同韵u）</p>
      <p>“打南边来了个瘸子，担了一挑子茄子，手里拿着个碟子，地下钉着木头橛子。没留神那橛子绊倒了瘸子，弄撒了瘸子的茄子，砸了瘸子的碟子，瘸子毛腰拾茄子。”</p>
      <p>名字举例：齐确切(ue 和 ie 后响复合韵母)</p>
      <p style="font-weight:600;">避免同调</p>
      <p>“老师老是叫老史去捞石,老史老是没有去捞石,老史老是骗老师,老师说老史不老实。”</p>
      <p>名字举例：史实石（同声shi） 吴五舞（同声wu）</p>
      <p style="font-weight:600;">总结，一个好听的名字，具有如下特征：</p>
      <p style="font-weight:600;">1、首先分析自己姓氏字的声调、声母、韵母特征。名字声调和姓氏搭配较好。</p>
      <p style="font-weight:600;">2、整体音调有一定的变化，尽量不选择三声。不选择三声相连、四声相连。</p>
      <p style="font-weight:600;">3、不选择近似的声母和韵母（含双声、叠韵等）。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
      text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
